document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[data-testimonial-swiper]');

  sliders.forEach((slider) => {
    if (slider.classList.contains('swiper-initialized')) return;

    const autoplayEnabled = slider.dataset.autoplay === 'true';
    const autoplaySpeed = Number(slider.dataset.autoplaySpeed) || 3000;

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      pagination: {
        el: slider.querySelector('.el-testimonial-slider__pagination'),
        clickable: true
      },
      autoplay: autoplayEnabled
        ? {
            delay: autoplaySpeed,
            disableOnInteraction: false
          }
        : false,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 14
        }
      }
    });
  });
});